import { BIRTH_POSTERS_CATEGORY_IDS } from './categoryIds';

export default (categoryId: number) => Boolean(BIRTH_POSTERS_CATEGORY_IDS[categoryId]);
